import { FC, useEffect, useRef } from 'react';
import {
  CopySimple,
  ArrowsOutCardinal,
  TrashSimple,
  FilePdf,
} from '@phosphor-icons/react';
import styles from './CoachSessionWeekView.module.scss';

interface SessionContextMenuProps {
  x: number;
  y: number;
  onDuplicate: () => void;
  onMove: () => void;
  onDelete: () => void;
  onExportPdf: () => void;
  onClose: () => void;
}

/**
 * Menu contestuale card sessione (right-click).
 * Spec v1.1.1 sez 2: Duplica / Sposta / Elimina / Esporta PDF.
 */
export const SessionContextMenu: FC<SessionContextMenuProps> = ({
  x,
  y,
  onDuplicate,
  onMove,
  onDelete,
  onExportPdf,
  onClose,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) onClose();
    };
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('mousedown', onClick);
    window.addEventListener('keydown', onEsc);
    return () => {
      window.removeEventListener('mousedown', onClick);
      window.removeEventListener('keydown', onEsc);
    };
  }, [onClose]);

  const maxX = typeof window !== 'undefined' ? window.innerWidth - 220 : x;
  const maxY = typeof window !== 'undefined' ? window.innerHeight - 200 : y;
  const posX = Math.min(x, maxX);
  const posY = Math.min(y, maxY);

  return (
    <div
      ref={ref}
      className={styles.contextMenu}
      style={{ left: posX, top: posY }}
    >
      <button
        type="button"
        className={styles.contextMenuItem}
        onClick={() => {
          onDuplicate();
          onClose();
        }}
      >
        <CopySimple size={13} />
        <span>Duplica</span>
      </button>
      <button
        type="button"
        className={styles.contextMenuItem}
        onClick={() => {
          onMove();
          onClose();
        }}
      >
        <ArrowsOutCardinal size={13} />
        <span>Sposta</span>
      </button>
      <button
        type="button"
        className={styles.contextMenuItem}
        onClick={() => {
          onExportPdf();
          onClose();
        }}
      >
        <FilePdf size={13} />
        <span>Esporta PDF</span>
      </button>
      <div className={styles.contextMenuSeparator} />
      <button
        type="button"
        className={`${styles.contextMenuItem} ${styles.contextMenuDanger}`}
        onClick={() => {
          onDelete();
          onClose();
        }}
      >
        <TrashSimple size={13} />
        <span>Elimina</span>
      </button>
    </div>
  );
};
